import axiosInstance from './axiosInstance';

/**
 * 나에게 맞는 공고 (배우 전용, 내 프로필 기준)
 *
 * 서버가 지금 열려 있는 배역 가운데 내 조건(성별·나이·키·스킬)에 맞는 것을 고르고,
 * 사진이 색인된 배우라면 배역 설명과 얼마나 어울리는지로 순서를 매겨 준다.
 * 요청할 때 모델을 부르지 않으므로 가볍다. 기능이 꺼졌거나 허용되지 않은 계정이면
 * AI 검색과 같은 방식으로 오류가 난다 — 화면은 오류를 모두 "없음"으로 보고 섹션을 숨긴다.
 *
 * 응답 (BE 계약 §3): 기존 공고/배역 카드 DTO + rank, fitPercentile, fitMode, reason.
 *   { status?: 'OK'|'NO_POSTINGS'|..., results: [{ rank, fitPercentile, fitMode, reason,
 *     post: { id, title, projectType, category, companyName, applicationDeadline, ... },
 *     role: { id, roleName, roleType, gender, ageMin, ageMax, heightMin, heightMax, skills, ... } }] }
 * 모양이 조금 달라도 화면 쪽 정규화(postingRecommendationModel)가 받아 준다.
 *
 * 개발 서버(npm start)에서 REACT_APP_AI_POSTINGS_MOCK=true 이면 서버 대신 가짜 응답을 준다.
 * 조건은 NODE_ENV를 먼저 본다 — 운영 빌드에서는 'production' !== 'production' → false로 접혀
 * 분기와 동적 import가 통째로 빠진다. 그래서 조건을 상수에 담지 않고 그 자리에 그대로 쓴다.
 *
 * @param {{ limit?: number }} [params]
 */
export const getAiPostingRecommendations = async ({ limit = 20 } = {}) => {
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_AI_POSTINGS_MOCK === 'true') {
    const { mockGetAiPostingRecommendations } = await import('./aiPostingsMock');
    return mockGetAiPostingRecommendations({ limit });
  }
  const res = await axiosInstance.get('/api/talent/ai-postings/recommendations', { params: { limit } });
  return res.data;
};
